import { isMobilityPulseAdsEnabled } from '@client/adManager/AdUnit/utils/isMobilityPulseAdsEnabled.js';
import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { trackAdViewable } from '@client/core/utils/pulse/adImpressions.js';
import {
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

import { debug as _debug } from './.debug.js';

const debug = _debug.withSublabel('Event', 'impressionViewable');

/** Fired when an impression becomes viewable. */
export function onImpressionViewable(
  event: googletag.events.ImpressionViewableEvent
) {
  const { slot } = event;
  const placementId = slot.getSlotElementId() as PlacementId;

  debug.withPlacementLabel(placementId).message('').verbose();
  updateMetricByKey(placementId, PlacementStatus.AdViewed);

  if (isMobilityPulseAdsEnabled()) trackAdViewable(slot);
}
